import * as H from 'history'
import { useHistory } from 'react-router'

import Button from 'components/common/Button'
import { Column, Columns } from 'components/common/Grid'
import Text from 'components/common/Text'
import theme from 'theme'
import { Service } from 'api'

const ServiceBasedAttackHeader: React.FC<{
  service: Service
  rerunAttackLink: H.LocationDescriptor
}> = ({ service, rerunAttackLink }) => {
  const history = useHistory()
  return (
    <Columns
      css={{ gridAutoColumns: 'auto', marginBottom: theme.space[4] }}
      gap={theme.space[3]}
    >
      <Column
        css={{
          minWidth: 0,
          maxWidth: '100%'
        }}
        span={11}
      >
        <Text overflowEllipsis as="h1">
          {service.name}
        </Text>
      </Column>
      <Column
        css={{
          display: 'grid',
          gridAutoFlow: 'column'
        }}
        justifySelf="end"
        span={5}
      >
        <Button
          data-test-view-service-details
          secondary
          data-track-action="view-service-details-from-attack-details"
          data-track-category="services"
          data-track-on="click"
          onClick={() => {
            history.push(`/services/detail/${service.id}`)
          }}
        >
          Service Details
        </Button>
        <Button
          data-test-rerun-attack
          css={{
            marginLeft: theme.space[3]
          }}
          data-track-action="rerun-service-attack-from-attack-details"
          data-track-category="services"
          data-track-on="click"
          onClick={() => {
            history.push(rerunAttackLink)
          }}
        >
          Rerun
        </Button>
      </Column>
    </Columns>
  )
}

export default ServiceBasedAttackHeader
